module.exports = __webpack_public_path__ + "static/media/ic_attendee_presenter.780a449e.svg";